import { Injectable } from '@angular/core';
import { HttpService } from '@app/@core/services/http.service';
import { DataSourceServiceConfig } from './data-source.url.config';

@Injectable({
  providedIn: 'root'
})
export class DataSourceService {

  constructor(private httpService: HttpService) {
    // This is intentional
  }
  getOrganizationDbs() {
    return this.httpService.get(DataSourceServiceConfig.EndPoint.Setting.getOrganizationDbs);
  }
  getSchema(dbAliasName: string) {
    return this.httpService.get(DataSourceServiceConfig.EndPoint.Setting.getList.replace('{dbaliasname}', dbAliasName));
  }
  SchemaCheck(id, dbaliasname) {
    return this.httpService.get(DataSourceServiceConfig.EndPoint.Setting.schemaCheck.replace('{organizationid}', id).replace('{dbaliasname}', dbaliasname));
  }
  updateData(data) {
    return this.httpService.post(DataSourceServiceConfig.EndPoint.Setting.updateData, data);
  }
  updateSchemaList(data) {
    return this.httpService.post(DataSourceServiceConfig.EndPoint.Setting.updateSchema, data);
  }
}
